module.exports = __webpack_public_path__ + "slick.ced611daf7709cc778da.eot";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.eot
// module id = ./node_modules/slick-carousel/slick/fonts/slick.eot
// module chunks = 2